"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityNameInconsistentRule = void 0;
exports.checkNamingConsistency = checkNamingConsistency;
exports.bestCase = bestCase;
exports.addCases = addCases;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
/**
 * Keeping the same naming convention for all your tables will help avoid typos and understand things.
 */
const ruleId = 'entity-name-inconsistent';
const ruleName = 'inconsistent entity name';
const ruleDescription = 'entities with names not following the most common convention among entity names';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
}).strict().describe('EntityNameInconsistentConf');
exports.entityNameInconsistentRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.low },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        const inconsistencies = checkNamingConsistency(db.entities || []);
        return inconsistencies.invalid
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, e)))
            .map(entity => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Entity ${(0, databaseUtils_1.entityRefToId)(entity)} doesn't follow naming convention ${inconsistencies.convention}.`,
            entity: entity
        }));
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/NamingConsistency.elm
function checkNamingConsistency(entities) {
    const counts = entities.reduce((acc, entity) => addCases(acc, entity.name), {});
    const entityCase = bestCase(counts);
    return {
        convention: entityCase.name,
        invalid: entities.filter(e => !entityCase.isValid(e.name)).map(databaseUtils_1.entityToRef)
    };
}
function bestCase(counts) {
    const bestCase = Object.entries(counts).reduce(([prevCase, prevCount], [curCase, curCount]) => {
        return curCount > prevCount ? [curCase, curCount] : [prevCase, prevCount];
    }, ['snake-lower', 0])[0];
    return [
        { name: 'camel-upper', isValid: utils_1.isCamelUpper },
        { name: 'camel-lower', isValid: utils_1.isCamelLower },
        { name: 'snake-upper', isValid: utils_1.isSnakeUpper },
        { name: 'snake-lower', isValid: utils_1.isSnakeLower },
        { name: 'kebab-upper', isValid: utils_1.isKebabUpper },
        { name: 'kebab-lower', isValid: utils_1.isKebabLower },
    ].find(c => c.name === bestCase) || { name: 'snake-lower', isValid: utils_1.isSnakeLower };
}
function addCases(acc, value) {
    return (0, utils_1.compatibleCases)(value).reduce((acc, c) => ({ ...acc, [c]: (acc[c] || 0) + 1 }), acc);
}
//# sourceMappingURL=entityNameInconsistent.js.map